import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: 'https://api.leitool.com/',
  // baseURL:'http://testapi.leitool.com',
  //withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(function(config){
    if(Cookies.get("userInfo")){
      var userInfo = JSON.parse(Cookies.get("userInfo"));
      var userId = userInfo ? userInfo.id:"";
      config.headers['token'] = Cookies.get("token") ? Cookies.get("token"):'';
      if(config.data){
        // config.data['uid'] = userId;
        config.data['uid'] = '6646';
      }
    }
    return config;  
  },
  function(error) {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 800 ) {
      if(res.code !== 300&&res.code !== 400){
        Message({
          message: res.msg || 'Error',
          type: 'success',
          duration: 3 * 1000
        })
      }else if(res.code == 400){
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 3 * 1000
        })
      }
    
      return res;
      // return Promise.reject(res.msg)
    } else {
      return res
    }
  }
)

export default service
